
<div class="container">
  <div *ngIf="userSubscriptionDetails">
    <app-customer-details-header-v2 
      [displaySubTypeLink]="displaySubTypeLink"
      [userSubscriptionDetails]="userSubscriptionDetails">
    </app-customer-details-header-v2>
  </div>
  <div class="freshpass-title-container mb24">
    <h2 class="freshpass-title" [innerHTML]="properties.freshpassData.freshpassManageTitle"></h2>
  </div>
    <div *ngIf="!!userSubscriptionDetails">
        <message-center [currentEnvironment]="currentEnvironment" [userInfo]="userInfo"
                        [userSubscriptionDetails]="userSubscriptionDetails"></message-center>
    </div>
    <div *ngIf="!userSubscriptionDetails" class="row">
        <div class="col-lg-6 col-md-12">
            <div class="loading-div-tiny" id="fp-loading">
                <div class="loading-spinner">
                    <div alt="Loading..." class="large progress">
                        <div class="prog1">
                            <div class="prog2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!!userSubscriptionDetails" class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <app-current-plan
                    [currentEnvironment]="currentEnvironment"
                    [showTenders]="isFPTenderAvailable"
                    [tenderInfo]="tenderInfo"
                    [userInfo]="userInfo"
                    [userSubscriptionDetails]="userSubscriptionDetails">
            </app-current-plan>
        </div>
        <div *ngIf="showTenders" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <app-current-payment [currentEnvironment]="currentEnvironment"
                                 [isFPTenderAvailable]="isFPTenderAvailable"
                                 [tenderInfo]="tenderInfo"
                                 [userInfo]="userInfo"
                                 [userSubscriptionDetails]="userSubscriptionDetails">
            </app-current-payment>
        </div>
    </div>
    <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <app-customer-service [currentEnvironment]="currentEnvironment" [userInfo]="userInfo"
                                  [userSubscriptionDetails]="userSubscriptionDetails"></app-customer-service>
        </div>
    </div>
    <div *ngIf="showTermsSection" class="mt-3 ml-3">
        <app-terms-and-conditions [currentEnvironment]="currentEnvironment" [userInfo]="userInfo"
                                  [userSubscriptionDetails]="userSubscriptionDetails"></app-terms-and-conditions>
    </div>
    <div *ngIf="!showTermsSection" class="shop-button-subs" id="shopAfterCancelSubs">
        <div class="row mt-5">
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3  pl0 mt8 m-pr0 m-mt16">
                <button (click)="shopAfterCancellation()" aria-label="Shop Now" class="btn btn-default secondarybtn"
                        data-test-id="shop-now-btn" tabindex="0">
                    {{properties.manage.SHOP_NOW}}
                </button>
            </div>
        </div>
    </div>
</div>

